import CancelRequestedTransactionsTab from "pages/transaction/tabs/CancelRequestedTransactionsTab";
import TransactionsListTab from "pages/transaction/tabs/TransactionsListTab";

export const TRANSACTION_TAB_ENTRIES = [
  { id: "transactions", label: "Transactions", Component: TransactionsListTab },
  {
    id: "cancelRequested",
    label: "Cancel Requested Transactions",
    Component: CancelRequestedTransactionsTab,
  },
];

export const TRANSACTION_TABS = TRANSACTION_TAB_ENTRIES.map(({ id, label }) => ({ id, label }));

const TAB_COMPONENT_BY_ID = Object.fromEntries(
  TRANSACTION_TAB_ENTRIES.map(({ id, Component }) => [id, Component]),
);

export function getTransactionTabComponent(tabId) {
  return TAB_COMPONENT_BY_ID[tabId] || TransactionsListTab;
}
